<template>
    <div class="ion-page">
        <ion-header class="rp-mobile">
        <ion-toolbar class="mobile-header-toolbar">
            <ion-buttons v-slot: start>
            <ion-back-button default-href="#" button @click="goBack"></ion-back-button>
            <ion-title>Reset Password</ion-title>
            <!-- default-href="/forgotpassword" -->
            </ion-buttons>
        </ion-toolbar>
        </ion-header>
        <ion-header class="rp-desktop">
        <ion-toolbar class="app-toolbar">
            <ion-buttons v-slot: start>
            <ion-back-button button @click="goBack"></ion-back-button>
            </ion-buttons>
            <ion-title>Reset Password</ion-title>
        </ion-toolbar>
        </ion-header>
        <ion-content class="ion-padding">
        <ResetPassword />
        </ion-content>
    </div>
</template>

<script>
import { defineComponent } from "vue";
import { IonHeader, IonToolbar, IonButtons, IonBackButton, IonTitle, IonContent } from "@ionic/vue";
import ResetPassword from "@/components/account/ResetPassword.vue";

export default defineComponent ({
    name: 'resetPassword',
    components: {
        ResetPassword,IonHeader, IonToolbar, IonButtons, IonBackButton, IonTitle, IonContent
    },
    data() {
        return {

        }
    },
    methods: {
        goBack() {
            window.history.length > 1 ? this.$router.go(-1) : this.$router.push('/forgotpassword')
        }
    }
})
</script>

<style scoped>
@media (max-width: 768px) {
  .mobile-header-toolbar {
    --background: #21b24b;
  }
  .mobile-header-toolbar {
    height: 56px;
    padding-top: 1px;
  }
  .mobile-header-toolbar ion-title {
    color: #ffffff;
  }
  .mobile-header-toolbar ion-buttons {
    color: #ffffff;
    --background: #ffffff;
  }
  .mobile-header-toolbar ion-back-button {
    color: #ffffff !important;
    margin-right: 13px;
  }
}
</style>